<mat-card class="main-container" appearance="outlined">
    <div class="top">
        <div class="title">
            <h3 [title]="employeeTimeOffType.timeOffType?.name">{{employeeTimeOffType.timeOffType?.name}}</h3>
            <p [title]="employeeTimeOffType.timeOffPolicy?.name">{{employeeTimeOffType.timeOffPolicy?.name}}</p>
        </div>

        <div class="admin-controls" *appTableAccess="[tableCreateAccessObj, tableUpdateAccessObj, tableDeleteAccessObj]">
            <button
                class="settings-button"
                mat-icon-button
                type="button"
                [matMenuTriggerFor]="settings"
                [attr.aria-label]="(employeeTimeOffType.timeOffType?.name || '') + ' ' + ('Options' | translate: {Default: 'options'})"
            >
                <mat-icon class="settings-button__icon material-icons-outlined" aria-hidden="true">more_vert</mat-icon>
            </button>
            <mat-menu #settings="matMenu" xPosition="before">
                <button class="settings-menu__item" appPreventDoubleClick (throttledClick)="openAssignPolicyDialog()" mat-menu-item *appTableAccess="[tableUpdateAccessObj]" appLocalizationPopupDirective localizationCode="EmployeeTimeOffTypeEdit">
                    <mat-icon class="material-icons-outlined">edit</mat-icon>
                    {{ 'EmployeeTimeOffTypeEdit' | translate: {Default: "Edit"} }}
                </button>
                <button class="settings-menu__item" appPreventDoubleClick (throttledClick)="openConfirmDeleteDialog()" mat-menu-item *appTableAccess="[tableDeleteAccessObj]" appLocalizationPopupDirective localizationCode="EmployeeTimeOffTypeDelete">
                    <mat-icon class="material-icons-outlined">delete</mat-icon>
                    {{ 'EmployeeTimeOffTypeDelete' | translate: {Default: "Delete"} }}
                </button>
                <button class="settings-menu__item" mat-menu-item appPreventDoubleClick (throttledClick)="openModifyBalanceFormDialog()" *appTableAccess="[tableUpdateAccessObj]" appLocalizationPopupDirective localizationCode="EmployeeTimeOffTypeModifyBalance">
                    <mat-icon class="material-icons-outlined">settings</mat-icon>
                    {{ 'EmployeeTimeOffTypeModifyBalance' | translate: {Default: "Modify Balance"} }}
                </button>
                <button class="settings-menu__item" mat-menu-item appPreventDoubleClick (throttledClick)="openModifyBalanceHistoryDialog()" *appTableAccess="[tableUpdateAccessObj]" appLocalizationPopupDirective localizationCode="EmployeeTimeOffTypeModifyBalanceHistory">
                    <mat-icon class="material-icons-outlined">history</mat-icon>
                    {{ 'EmployeeTimeOffTypeModifyBalanceHistory' | translate: {Default: "Modify Balance History"} }}
                </button>
                <button class="settings-menu__item" mat-menu-item appPreventDoubleClick (throttledClick)="openCalculationLogDialog()" *appTableAccess="[tableUpdateAccessObj]" appLocalizationPopupDirective localizationCode="EmployeeTimeOffTypeCalculationLog">
                    <mat-icon class="material-icons-outlined">calculate</mat-icon>
                    {{ 'EmployeeTimeOffTypeCalculationLog' | translate: {Default: "Calculation Log"} }}
                </button>
                <button class="settings-menu__item" mat-menu-item appPreventDoubleClick (throttledClick)="openCalculationEntriesReport()" *appTableAccess="[tableUpdateAccessObj]" appLocalizationPopupDirective localizationCode="TimeOffCalculationEntriesReport">
                    <mat-icon class="material-icons-outlined">calculate</mat-icon>
                    {{ 'TimeOffCalculationEntriesReport' | translate: {Default: "Time Off Calculation Entries Report"} }}
                </button>
            </mat-menu>
        </div>
    </div>

    <div class="balance-container">
        <div class="label">
            <span appLocalizationPopupDirective localizationCode="EmployeeTimeOffTypeBalance">
                {{ 'EmployeeTimeOffTypeBalance' | translate: {Default: "Balance"} }}
            </span>
        </div>
        <div class="balance">
            <ng-container *ngIf="employeeTimeOffType.availableHours; else noAvailableHours">
                <span class="balance-value" setColor="primaryColour">{{employeeTimeOffType.availableHours | number:'1.2-2' }}</span>
            </ng-container>
            <ng-template #noAvailableHours>
                <span class="balance-value">0</span>
            </ng-template>
        </div>
        <div class="hours">
            <span appLocalizationPopupDirective localizationCode="EmployeeTimeOffTypeHours">
                {{ 'Hours' | translate: {Default: "Hours"} }}
            </span>
        </div>
    </div>

    <div class="carry-over-details">
        <div class="row" *ngIf="employeeTimeOffType.timeOffPolicy?.showMaximumCarryOverToEndUser === true && employeeTimeOffType.timeOffPolicy?.carryOverAmount !== null">
            <span appLocalizationPopupDirective localizationCode="EmployeeTimeOffTypeCarryOverAmount">
                {{ 'CarryOverAmount' | translate: {Default: "Carry Over Amount"} }} : 
            </span>
            <span>
                {{employeeTimeOffType.timeOffPolicy?.carryOverAmount}} 
            </span>
            <span appLocalizationPopupDirective localizationCode="EmployeeTimeOffTypeHours">
                {{  'EmployeeTimeOffTypeHours' | translate: {Default: "Hours"} }}
            </span>
        </div>
        <div class="row" *ngIf="employeeTimeOffType.timeOffPolicy?.showCarryOverDateToEndUser === true && employeeTimeOffType.timeOffPolicy?.carryOverDay !== null && employeeTimeOffType.timeOffPolicy?.carryOverMonth !== null" appLocalizationPopupDirective localizationCode="EmployeeTimeOffTypeCarryOverDate">
            {{ 'EmployeeTimeOffTypeCarryOverDate' | translate: {Default: "Carry Over Date"} }} : {{employeeTimeOffType.timeOffPolicy?.carryOverDay}}/{{employeeTimeOffType.timeOffPolicy?.carryOverMonth}}
        </div>
    </div>

    <!-- <div class="buttons-container">
        <button mat-stroked-button color="primary" appPreventDoubleClick (throttledClick)="openLeaveRequestDialog()">
            {{ 'EmployeeTimeOffTypeRequestTimeOff' | translate: {Default: "Request Time Off"} }}
        </button>
    </div> -->
</mat-card>